// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your JavaScript code.




class Rect {
    constructor(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
}

class Neck {

    constructor(ctx, neck, nutWidth) {
        
        this.nutWidth = nutWidth;
        this.neckRect = new Rect(neck.x , neck.y, neck.width , neck.height);
        this.fbRect = new Rect(neck.x + this.nutWidth, neck.y, neck.width - this.nutWidth, neck.height);
        this.ctx = ctx
        console.log(neck.width);
    }

    getFbRect() { return this.fbRect;}

    drawFretboard() {
        console.log(this.fbRect.width);
        this.ctx.fillStyle = bgColor;
        this.ctx.fillRect(this.fbRect.x, this.fbRect.y, this.fbRect.width, this.fbRect.height)

        this.ctx.beginPath();
        this.ctx.fillStyle = borderColor;
        this.ctx.moveTo(this.fbRect.x, this.fbRect.y)
        this.ctx.rect(this.fbRect.x, this.fbRect.y, this.fbRect.width, this.fbRect.height)
        this.ctx.stroke();
    }

    drawNut() {
   
        this.ctx.fillStyle = nutColor;
        this.ctx.fillRect(this.neckRect.x, this.neckRect.y, this.nutWidth, this.neckRect.height)
        this.ctx.stroke();

        this.drawNutNote(1, 'E');
        this.drawNutNote(2, 'B');
        this.drawNutNote(3, 'G');
        this.drawNutNote(4, 'D');
        this.drawNutNote(5, 'A');
        this.drawNutNote(6, 'E');
    }

    drawNutNote(stringNum, noteName) {
        let x = this.nutWidth / 2;
        let strSpace = this.fbRect.height / numOfStrings;
        let y = (strSpace / 2) + strSpace * (stringNum - 1);
     
        this.ctx.font = noteFont;
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = nutTextColor;
        this.ctx.fillText(noteName, x, y);
    }


    drawCagedSection(x1,x2,colour) {
        //this.ctx.fillStyle = colour;
        //this.ctx.fillRect(x1, this.fbRect.y, x2 - x1, this.fbRect.height);


        this.ctx.beginPath();
        //this.ctx.fillStyle = colour;

        this.ctx.lineWidth = cagedBoxLineWidth;
        this.ctx.strokeStyle = colour;
        this.ctx.moveTo(x1, this.fbRect.y)
        this.ctx.rect(x1, this.fbRect.y, x2 - x1, this.fbRect.height)
        this.ctx.stroke();

    }

    draw() {
        this.drawFretboard();
        this.drawNut();
    }

}

class Fret {
    constructor(ctx, neck, fretNumber) {
        this.neck = neck;
        this.fretNumber = fretNumber;

        this.xPos = this.neck.x + ((this.neck.width * fretNumber) / numOfFrets);
        this.yPos = this.neck.y + this.neck.height;
    }

    draw() {
        console.log(this.neck.width);
        this.ctx.moveTo(this.xPos, this.neck.y);
        this.ctx.lineTo(this.xPos, this.yPos)
        this.ctx.stroke();
    }
}

// draw frets (ctx, neck)

class Frets {
    constructor(ctx, neck) {
        this.ctx = ctx;
        this.neck = neck;
        console.log(neck.x);
    }

    drawFrets() {
        this.ctx.strokeStyle = this.fretColor;
        this.ctx.lineWidth = 1;
        let fret = 0;
        for (fret = 0; fret < numOfFrets; fret++) {
            console.log(fret);

            this.drawFret(fret);
        }
    }

    getFretGap() {
        let fretGap = this.neck.width / numOfFrets;
        return fretGap;
    }

    getStringGap() {
        let stringGap = this.neck.height / numOfStrings;
        return stringGap;
    }

    getXPos(fretNumber) {
        let xPos = this.neck.x + ((this.neck.width * fretNumber) / numOfFrets);
        return xPos;
    }

    getNoteXPos(fretNumber) {
        let xPos = this.neck.x + ((this.neck.width * fretNumber) / numOfFrets) - (this.neck.width / numOfFrets)/2;
        return xPos;
    }

    drawFret(fretNumber) {
        let yPos = this.neck.y + this.neck.height;
        let xPos = this.getXPos(fretNumber);

        console.log(this.neck.width);
       
        this.ctx.moveTo(xPos, this.neck.y);
        this.ctx.lineTo(xPos, yPos)
        this.ctx.stroke();
    }
}

// draw the strings (ctx, neck)
class Strings {
    constructor(ctx, fbRect,nutWidth,stringColor) {
        console.log(fbRect.x);
        this.ctx = ctx;
        this.fbRect = fbRect;
        this.nutWidth = nutWidth;
        this.stringColor = stringColor;
    }

    drawStrings() {

        this.ctx.lineWidth = 1;
        for (let stringNum = 1; stringNum < numOfStrings + 1; stringNum++) {
            console.log(stringNum);
            this.drawString(stringNum);

        }
    }

    getYPos(stringNum) {
        let yStart = ((this.fbRect.height / (numOfStrings + 1)) / 2);
        let yInc = this.fbRect.height / numOfStrings;

        let yPos = (stringNum < 2) ? yStart : (yStart + (yInc * (stringNum - 1)));
        return yPos;
    }

    drawStringLines(width,yPos) {
        this.ctx.strokeStyle = this.stringColor;
        this.ctx.moveTo(this.fbRect.x , yPos - width);
        this.ctx.lineTo(this.fbRect.width + this.nutWidth, yPos - width);

        this.ctx.moveTo(this.fbRect.x , yPos + width);
        this.ctx.lineTo(this.fbRect.width + this.nutWidth, yPos + width);

    }

    drawString(stringNum) {
        let yPos = this.getYPos(stringNum);
        console.log(yPos);

        if ((stringNum == '1') || (stringNum == '2') ||(stringNum == '3')  ) {
            let width = 0;
            this.drawStringLines(width, yPos);

            this.drawStringLines(width, yPos);
        }

        if(stringNum == '4') {
            let width = 1;
            this.drawStringLines(width, yPos);

            this.drawStringLines(width, yPos);
        }

        if (stringNum == '5') {
            let width = 2;
            this.drawStringLines(width, yPos);

            width = 1;
            this.drawStringLines(width, yPos);
        }

        if (stringNum == '6') {
            let width = 3;
            this.drawStringLines(width,yPos);

            width = 2;
            this.drawStringLines(width,yPos);
        }

        this.ctx.stroke();
    }
}

// draw notes on the fretboard (ctx, frets,strings)
// method drawNote(fretNum, stringNum, txt)
class FretboardNotes {

   
    constructor(ctx, frets, strings, sharpsOrFlats) {
        this.sharpsOrFlats = sharpsOrFlats;
        this.ctx = ctx;
        this.frets = frets;
        this.strings = strings;

        // Initialize arrays with size 7 to use 1-based indexing (strings numbered 1-6)
        this.stringNotes = new Array(7);

        this.stringNotes[1] = new Array('E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#');
        this.stringNotes[2] = new Array('B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#');
        this.stringNotes[3] = new Array('G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#');
        this.stringNotes[4] = new Array('D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#');
        this.stringNotes[5] = new Array('A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#');
        this.stringNotes[6] = new Array('E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B', 'C', 'C#', 'D', 'D#');
        this.rootFretByString = new Array(7);
        
        // Define base octave for each string (standard tuning: E2, A2, D3, G3, B3, E4)
        // Using 1-based indexing to match string numbering
        this.stringBaseOctave = new Array(7);
        this.stringBaseOctave[1] = 4; // High E string (E4)
        this.stringBaseOctave[2] = 3; // B string (B3)
        this.stringBaseOctave[3] = 3; // G string (G3)
        this.stringBaseOctave[4] = 3; // D string (D3)
        this.stringBaseOctave[5] = 2; // A string (A2)
        this.stringBaseOctave[6] = 2; // Low E string (E2)
    }

    drawNashNumber(fretNum, stringNum, txt, numNote, nashNumber)
    {

        // get centre note position 
        let xC = this.frets.getNoteXPos(fretNum);
        let yC = this.strings.getYPos(stringNum);

        let xOff = 1;
        let yOff = 1;

        if ((nashNumber < 1) || (nashNumber > 7))
            return;

        if (nashNumber == 1) { xOff = 0; yOff = -1.4; }
        if (nashNumber == 2) { xOff = 1; yOff = -1; }
        if (nashNumber == 3) { xOff = 1.4; yOff = 0; }
        if (nashNumber == 4) { xOff = 1; yOff = 1; }
        if (nashNumber == 5) { xOff = 0; yOff = 1.4; }
        if (nashNumber == 6) { xOff = -1; yOff = 1; }
        if (nashNumber == 7) { xOff = -1; yOff = -1; }

        // get nash num offset
        let x = xC + ((noteDiam / 2) * xOff);
        let y = yC + ((noteDiam / 2) * yOff);

        let nashColorList = new Array("white", "yellow", "lime", "red", "blue", 'cyan', 'brown');

        let nashNumDiamLoc = 6; 
        // draw note shape 
        this.ctx.beginPath();
        this.ctx.arc(x, y, nashNumDiamLoc, 0, 2 * Math.PI);
        let noteColorLoc = nashColorList[nashNumber-1];
        this.ctx.fillStyle = noteColorLoc;
        this.ctx.fill();

        let nashFont = "10px Arial";
        let nashText = new Array("I", "ii", "iii", "IV", "V", 'vi', 'vii');
        
        this.ctx.font = nashFont;
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "black";
        //nashTextColor[nashNumber];
        this.ctx.fillText(nashText[nashNumber-1], x, y);
        
/*        const nashNumDiam = 7
const nashMax = 7
const nashFont = "5px Arial";
let nashColors = new Array("red", "blue", "green", "orange", "yellow",'white','purple');
let nashText = new Array("I", "ii", "iii", "IV", "V", 'vi', 'vii');
*/

    }

    arrayContains(needle, arrhaystack) {
        return (arrhaystack.indexOf(needle) > -1);
    }

    noteInNashChord(numNote, nashChord) {

        let nash1 = ["1", "3", "5"];
        let nash2 = ["2", "4", "6"];
        let nash3 = ["3", "5", "7"];
        let nash4 = ["4", "1", "6"];
        let nash5 = ["5", "2", "7"];
        let nash6 = ["6", "1", "3"];

        if (nashChord == 1 && this.arrayContains(numNote, nash1))
            return true;
        if (nashChord == 2 && this.arrayContains(numNote, nash2))
            return true;
        if (nashChord == 3 && this.arrayContains(numNote, nash3))
            return true;
        if (nashChord == 4 && this.arrayContains(numNote, nash4))
            return true;
        if (nashChord == 5 && this.arrayContains(numNote, nash5))
            return true;
        if (nashChord == 6 && this.arrayContains(numNote, nash6))
            return true;
        else
            return false;
    }
    
    drawAllNashNumbers(fretNum, stringNum, txt, numNote, notesOrNumbers) {

        for (let nashChord = 1; nashChord < 8; nashChord++) {

            if (this.noteInNashChord(numNote, nashChord)) {
                this.drawNashNumber(fretNum, stringNum, txt, numNote, nashChord);
            }
        }
    }

    noteInMajorPent(numNote) {

        let majorPentLoc = ["1", "2", "3", "5", "6"];
      
        if (this.arrayContains(numNote, majorPentLoc))
            return true;
        else
            return false;
    }

    /*noteInPent(numNote, notesOrNumbers) {
        Boolean inPent =
            (numNote === "1" || numNote === "7") ? true : false;

        return inPent;
    }*/

    drawNote(fretNum, stringNum, txt, numNote, notesOrNumbers) {

        // get note position 
        let x = this.frets.getNoteXPos(fretNum);
        let y = this.strings.getYPos(stringNum);

        // draw note shape 
        this.ctx.beginPath();
        this.ctx.arc(x, y, noteDiam, 0, 2 * Math.PI);
        let noteColorLoc = (numNote === "1") ? noteColorRoot : noteColor;
        /*if (notesOrNumbers === "intervals")
            noteColorLoc = (numNote === "3" || numNote === "b3" || numNote === "5") ? noteChordColor : noteColorLoc;
        if (notesOrNumbers === "intervals")
            noteColorLoc = (numNote === "2" || numNote === "6") ? notePentColor : noteColorLoc;
        if (notesOrNumbers === "intervals")*/
    
        this.ctx.fillStyle = noteColorLoc;
        this.ctx.fill();

        // draw notetext 
        
        if (notesOrNumbers == "both")
            this.ctx.font = noteSmallFont;
        else
            this.ctx.font = noteFont;

        


        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        let noteTextColorLoc = (numNote === "1") ? noteTextColorRoot : noteTextColor;
        //noteTextColorLoc = (!this.noteInMajorPent(numNote)) ? noteModeColor : noteTextColorLoc;

        
    
        this.ctx.fillStyle = noteTextColorLoc;
        this.ctx.fillText(txt, x, y);

      

    }


    drawInlay(fretNum) {

        let x = this.frets.getNoteXPos(fretNum);
        let halfStringGap = (this.strings.getYPos(4) - this.strings.getYPos(3))/2;

        let y = this.strings.getYPos(3) + halfStringGap;

        if (fretNum == 12)
            y = this.strings.getYPos(2) + halfStringGap;

        this.ctx.beginPath();
        this.ctx.arc(x, y, inlayDiam, 0, 2 * Math.PI);
        this.ctx.fillStyle = inlayColor;
        this.ctx.fill();

        if (fretNum == 12) {
            y = this.strings.getYPos(4) + halfStringGap;
            this.ctx.beginPath();
            this.ctx.arc(x, y, inlayDiam, 0, 2 * Math.PI);
            this.ctx.fillStyle = inlayColor;
            this.ctx.fill();
        }

    }

    drawInlays() {

        this.drawInlay(3);
        this.drawInlay(5);
        this.drawInlay(7);
        this.drawInlay(9);
        this.drawInlay(12);
        this.drawInlay(15);
    }

    drawFretboardNotes(keyNotes, notesOrNumbers,showTargets) {

        for (let stringNum = 1; stringNum <= numOfStrings; stringNum++) {    
            for (let fretNum = firstNoteFret; fretNum <= numOfFrets; fretNum++) {

                let noteName = this.stringNotes[stringNum][fretNum];

                // before drawing
                //[1] change to noteNumber (for key)and retain this
                let noteNum = keyNotes.numNoteFromName(noteName);

                //[2] check if this is in the scale selection
                let valid = keyNotes.checkValid(noteNum);

                if (valid) {

                    if (this.sharpsOrFlats != "#")
                        noteName = keyNotes.toFlat(noteName);

                    // display note or number


                    let txt = noteName;
                    if (notesOrNumbers == "intervals")
                        txt = noteNum;
                    if (notesOrNumbers == "both")
                        txt = noteNum + noteName;

                    if (noteNum == 1)
                        txt = noteName;

                    this.drawNote(fretNum, stringNum, txt, noteNum, notesOrNumbers);

                    if (showTargets == true)
                        this.drawAllNashNumbers(fretNum, stringNum, txt, noteNum, notesOrNumbers);
                }
            }
        }
    }

    drawCagedMajShapes(keyNotes, neck) {

        for (let stringNum = 1; stringNum <= numOfStrings; stringNum++) {
            for (let fretNum = numOfFrets; fretNum >= firstNoteFret; fretNum--) {

                let noteName = this.stringNotes[stringNum][fretNum];
                let noteNum = keyNotes.numNoteFromName(noteName);

                let valid = keyNotes.checkValid(noteNum);

                if (valid) {

                    if (noteNum == 1) {
                        this.rootFretByString[stringNum] = fretNum;

                        if (stringNum == 1)
                            this.drawCagedShapeEMaj(keyNotes, neck);
                        if (stringNum == 2)
                            this.drawCagedShapeCMaj(keyNotes, neck);
                        if (stringNum == 3)
                            this.drawCagedShapeGMaj(keyNotes, neck);
                        if (stringNum == 4)
                            this.drawCagedShapeDMaj(keyNotes, neck);
                        if (stringNum == 5)
                            this.drawCagedShapeAMaj(keyNotes, neck);
                    }
                }
            }
        }
    }


    drawCagedMinShapes(keyNotes, neck) {

        for (let stringNum = 1; stringNum <= numOfStrings; stringNum++) {
            for (let fretNum = numOfFrets; fretNum >= firstNoteFret; fretNum--) {

                let noteName = this.stringNotes[stringNum][fretNum];
                let noteNum = keyNotes.numNoteFromName(noteName);

                let valid = keyNotes.checkValid(noteNum);

                if (valid) {

                    if (noteNum == 1) {
                        this.rootFretByString[stringNum] = fretNum;

                        if (stringNum == 1)
                            this.drawCagedShapeEMin(keyNotes, neck);
                        if (stringNum == 2)
                            this.drawCagedShapeCMin(keyNotes, neck);
                        if (stringNum == 3)
                            this.drawCagedShapeGMin(keyNotes, neck);
                            
                        if (stringNum == 4)
                            this.drawCagedShapeDMin(keyNotes, neck);
                        
                        if (stringNum == 5)
                            this.drawCagedShapeAMin(keyNotes, neck);
                    }
                }
            }
        }
    }


    drawFretboardCagedShapes(keyNotes, neck) {

        this.drawCagedMajShapes(keyNotes, neck);
    }




    drawCagedShapeCMaj(keyNotes, neck) {

        let rootFret = this.rootFretByString[2];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(2);

        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();


        // draw notetext 
        this.ctx.font = "100px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX - xGap;
        let right = rtX + (xGap * 2)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);
        this.ctx.fillText("C", xMid, yMid);

        // draw shape
        this.ctx.beginPath();
        this.ctx.strokeStyle = "green";
        this.ctx.lineWidth = 10;

      

        //B str to E str
        this.ctx.moveTo(rtX+5, rtY);
        let x = rtX - xGap;
        let y = rtY - yGap;
        this.ctx.lineTo(x+5, y);
        this.ctx.stroke();


        //B str to G str
        this.ctx.moveTo(rtX + 5, rtY);
        x = rtX - xGap;
        y = rtY + yGap;
        this.ctx.lineTo(x + 5, y);
        this.ctx.stroke();

        this.ctx.moveTo(x+5, y);
        x = rtX + xGap;
        y = rtY + (yGap * 2);
        this.ctx.lineTo(x+5, y);
        this.ctx.stroke();

        this.ctx.moveTo(x-5, y);
        y = y + yGap;
        x = x + xGap;
        this.ctx.lineTo(x-5, y);
        this.ctx.stroke();

        y = y + yGap;
        this.ctx.lineTo(x-5, y);
        this.ctx.stroke();

        this.ctx.lineWidth = 1;
        
    }

    drawCagedShapeCMin(keyNotes, neck) {

        let rootFret = this.rootFretByString[2];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(2);

        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();


        // draw notetext 
        this.ctx.font = "80px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX - xGap;
        let right = rtX + (xGap * 2)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);
        this.ctx.fillText("Cm", xMid, yMid);

        // draw shape
        this.ctx.beginPath();
        this.ctx.strokeStyle = "green";
        this.ctx.lineWidth = 10;

        // B str to G str
        this.ctx.moveTo(rtX + 5, rtY);
        let x = rtX - xGap;
        let y = rtY + yGap;
        this.ctx.lineTo(x + 5, y);
        this.ctx.stroke();

        // G str to D str
        this.ctx.moveTo(x + 5, y);
        x = x + xGap;
        y = y + yGap;
        this.ctx.lineTo(x + 5, y);
        this.ctx.stroke();

        // D str to A str
        this.ctx.moveTo(x, y);
        x = x + (xGap * 2);
        y = y + (yGap);
        this.ctx.lineTo(x - 5, y);
        this.ctx.stroke();

       
        y = y + yGap;
        this.ctx.lineTo(x - 5, y);
        this.ctx.stroke();

        this.ctx.lineWidth = 1;

    }


    drawCagedShapeDMaj(keyNotes, neck) {

        let rootFret = this.rootFretByString[4];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(4);

        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();



        // draw notetext 
        this.ctx.font = "100px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX ;
        let right = rtX + (xGap * 3)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);
        this.ctx.fillText("D", xMid, yMid);


        // draw shape
        this.ctx.beginPath();
        this.ctx.strokeStyle = "yellow";
        this.ctx.lineWidth = 10;

        this.ctx.moveTo(rtX, rtY);
        let x = rtX + (xGap * 2);
        let y = rtY - yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x-10, y);
        y = y - yGap;
        x = x + xGap;
        this.ctx.lineTo(x-10, y);
        this.ctx.stroke();

        this.ctx.moveTo(x-10, y);
        y = y - yGap;
        x = x - xGap ;
        this.ctx.lineTo(x-10, y);
        this.ctx.stroke();

        this.ctx.moveTo(rtX+5, rtY);
        y = rtY + yGap;
        this.ctx.lineTo(rtX+5, y);
        this.ctx.stroke();

        this.ctx.moveTo(rtX + 5, y);
        y = y + yGap;
        x = rtX + (xGap *2)
        this.ctx.lineTo(x, y);
        this.ctx.stroke();
        

        this.ctx.lineWidth = 1;
    }

    drawCagedShapeDMin(keyNotes, neck) {

        let rootFret = this.rootFretByString[4];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(4);

        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();



        // draw notetext 
        this.ctx.font = "80px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX;
        let right = rtX + (xGap * 3)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);
        this.ctx.fillText("Dm", xMid, yMid);


        // draw shape
        this.ctx.beginPath();
        this.ctx.strokeStyle = "yellow";
        this.ctx.lineWidth = 10;

        //D string to G string
        this.ctx.moveTo(rtX, rtY);
        let x = rtX + (xGap * 2);
        let y = rtY - yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();


        //G to E str
        let Ey = y - (yGap * 2);
        let Ex = rtX + xGap;
        this.ctx.lineTo(Ex, Ey);
        this.ctx.stroke();

        //G str to B str
        this.ctx.moveTo(x - 10, y);
        y = y - yGap;
        x = x + xGap;
        this.ctx.lineTo(x - 10, y);
        this.ctx.stroke();

        //G str to D str
        x = x - xGap;
        y = y + yGap;
        this.ctx.moveTo(x - 10, y);
        y = y + yGap;
        x = x + xGap;
        this.ctx.lineTo(x - 10, y);
        this.ctx.stroke();


        //B to E str
        /*this.ctx.moveTo(x - 10, y);
        y = y - yGap;
        x = x - (yGap * 2);
        this.ctx.lineTo(x - 10, y);
        this.ctx.stroke();*/

        // D to A string
        this.ctx.moveTo(rtX + 5, rtY);
        y = rtY + yGap;
        this.ctx.lineTo(rtX + 5, y);
        this.ctx.stroke();

        this.ctx.moveTo(rtX + 5, y);
        y = y + yGap;
        x = rtX + (xGap )
        this.ctx.lineTo(x, y);
        this.ctx.stroke();
        

        this.ctx.lineWidth = 1;
    }

    drawCagedShapeEMaj(keyNotes, neck) {

        let rootFret = this.rootFretByString[1];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(1);
        
        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();



        // draw notetext 
        this.ctx.font = "100px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX;
        let right = rtX + (xGap * 2)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);


        this.ctx.fillText("E", xMid, yMid);

        // draw shape
        this.ctx.beginPath();
        this.ctx.strokeStyle = "orange";
        this.ctx.lineWidth = 10;


        this.ctx.moveTo(rtX, rtY);
        let x = rtX;
        let y = rtY + yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y + yGap;
        x = x + xGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y + yGap;
        x = x + xGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x-5, y);
        y = y + yGap;
        this.ctx.lineTo(x-5, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        x = rtX;
        y = y + yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.lineWidth = 1;
    }

    drawCagedShapeEMin(keyNotes, neck) {

        let rootFret = this.rootFretByString[1];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(1);

        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();



        // draw notetext 
        this.ctx.font = "80px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX;
        let right = rtX + (xGap * 2)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);


        this.ctx.fillText("Em", xMid, yMid);

        // draw shape
        this.ctx.beginPath();
        this.ctx.strokeStyle = "orange";
        this.ctx.lineWidth = 10;

        //root to 5th on B  
        this.ctx.moveTo(rtX, rtY);
        let x = rtX;
        let y = rtY + (yGap * 2);
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

       
        this.ctx.moveTo(x, y);
        y = y + yGap;
        x = x + (xGap*2);
        this.ctx.lineTo(x-5, y);
        this.ctx.stroke();

     
        this.ctx.moveTo(x - 5, y);
        y = y + yGap;
        this.ctx.lineTo(x - 5, y);
        this.ctx.stroke();

        this.ctx.moveTo(x-5, y);
        x = rtX;
        y = y + yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.lineWidth = 1;
    }

    drawCagedShapeAMaj(keyNotes, neck) {
        
        let rootFret = this.rootFretByString[5];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(5);
     
        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();

        // draw notetext 
        this.ctx.font = "100px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX;
        let right = rtX + (xGap * 2)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);
        this.ctx.fillText("A", xMid, yMid);

        rtX -= 5;

        // draw shape
        this.ctx.beginPath();
        this.ctx.strokeStyle = "red";
        this.ctx.lineWidth = 10;


        this.ctx.moveTo(rtX+10, rtY);
        let x = rtX;
        let y = rtY + yGap;
        this.ctx.lineTo(x+10, y);
        this.ctx.stroke();


        this.ctx.moveTo(rtX, rtY);
        x = rtX + (xGap * 2);
        y = rtY - yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y - yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y - yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y - yGap;
        this.ctx.lineTo(rtX, y);
        this.ctx.stroke();

        this.ctx.lineWidth = 1;
    

    }

    drawCagedShapeAMin(keyNotes, neck) {

        let rootFret = this.rootFretByString[5];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(5);

        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();

        // draw notetext 
        this.ctx.font = "80px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX;
        let right = rtX + (xGap * 2)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);
        this.ctx.fillText("Am", xMid, yMid);

        rtX -= 5;

        // draw shape
        this.ctx.beginPath();
        this.ctx.strokeStyle = "red";
        this.ctx.lineWidth = 10;

        // A str to E str
        this.ctx.moveTo(rtX + 10, rtY);
        let x = rtX;
        let y = rtY + yGap;
        this.ctx.lineTo(x + 10, y);
        this.ctx.stroke();

        // A str to D str
        this.ctx.moveTo(rtX, rtY);
        x = rtX + (xGap * 2);
        y = rtY - yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        //G str to B str
        this.ctx.moveTo(x, y);
        y = y - yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y - yGap;
        x = x - xGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y - yGap;
        this.ctx.lineTo(rtX, y);
        this.ctx.stroke();

        this.ctx.lineWidth = 1;


    }

    drawCagedShapeGMaj(keyNotes, neck) {

        // get root from G string

        let rootFret = this.rootFretByString[3];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(2);

      
        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();

        // draw notetext 
        this.ctx.font = "100px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX;
        let right = rtX + (xGap * 3)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);
        this.ctx.fillText("G", xMid, yMid);


        rtX += 5;
        // draw shape

        this.ctx.beginPath();
        this.ctx.strokeStyle = "blue";
        this.ctx.lineWidth = 10;

        let x = rtX;
        let y = rtY;
        this.ctx.moveTo(x, y);
        x = x + (xGap * 3);
        y = y - yGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();


        this.ctx.moveTo(rtX, rtY);
        x = rtX;
        y = rtY + (yGap * 2);
        this.ctx.lineTo(x, y);
        this.ctx.stroke();


        this.ctx.moveTo(x, y);
        y = y + yGap;
        x = x + (xGap*2)
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y + yGap;
        x = x + xGap;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.lineWidth = 1;

    }

    drawCagedShapeGMin(keyNotes, neck) {

        // get root from G string

        let rootFret = this.rootFretByString[3];
        let rtX = this.frets.getNoteXPos(rootFret);
        let rtY = this.strings.getYPos(3);


        let xGap = this.frets.getFretGap();
        let yGap = this.frets.getStringGap();

        // draw notetext 
        this.ctx.font = "80px Arial";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "lightgrey";
        let left = rtX;
        let right = rtX + (xGap * 3)
        let half = (right - left) / 2;
        let xMid = left + half;
        let yMid = this.strings.getYPos(6);
        this.ctx.fillText("Gm", xMid, yMid);


        // draw shape

        this.ctx.beginPath();
        this.ctx.strokeStyle = "blue";
        this.ctx.lineWidth = 10;


        // G str to B str

        let x = rtX;
        let y = rtY;
        this.ctx.moveTo(x, y);
        x = x + (xGap * 3);
        y = y - yGap;
        this.ctx.lineTo(x-5, y);
        this.ctx.stroke();

        // B str to E str
        this.ctx.moveTo(x-10, y);
        y = y - (yGap ) ;
        this.ctx.lineTo(x-10, y);
        this.ctx.stroke();

        // G str to D
        this.ctx.moveTo(rtX+5, rtY);
        x = rtX;
        y = rtY + (yGap);
        this.ctx.lineTo(x+5, y);
        this.ctx.stroke();


        this.ctx.moveTo(x, y);
        y = y + yGap;
        x = x + (xGap )
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.moveTo(x, y);
        y = y + yGap;
        x = x + (xGap * 2);
        this.ctx.lineTo(x, y);
        this.ctx.stroke();

        this.ctx.lineWidth = 1;

    }


   
  /*  drawFretboardCagedSections(keyNotes, neck) {

        let cagedColors = new Array("red", "blue", "green", "orange", "yellow");

        getRootFretPerString(keyNotes, neck);

        for (let stringNum = 1; stringNum <= numOfStrings -1; stringNum++)
        {
            let fretNum = this.rootFretByString[stringNum];
            let x1 = this.frets.getNoteXPos(fretNum);
          //  let note = this.nutNote[stringNum];
            let offset = 2;

            //if (note == 'G' || note == 'D' )
            //  offset = 3;
            if (stringNum == 3 || stringNum == 4)
                offset = 3;

            let x2 = this.frets.getNoteXPos(fretNum + offset);
            
            if (stringNum < 6) {

                let col = cagedColors[stringNum];

                if (x2 > x1)
                neck.drawCagedSection(x1,x2, col);
            }
        }
    }
    */

    // Calculate the octave for a given string and fret position
    getOctaveForFret(stringNum, fretNum) {
        const baseOctave = this.stringBaseOctave[stringNum];
        const noteName = this.stringNotes[stringNum][fretNum];
        const baseNoteName = this.stringNotes[stringNum][0]; // Open string note
        
        // Note names that indicate we've crossed into a new octave
        // When we go from B to C, or when we go past the 12th fret
        const noteOrder = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
        const baseNoteIndex = noteOrder.indexOf(baseNoteName);
        const currentNoteIndex = noteOrder.indexOf(noteName);
        
        let octaveOffset = 0;
        
        // If current note is before the base note in the chromatic scale, we've crossed into next octave
        if (currentNoteIndex < baseNoteIndex) {
            octaveOffset = 1;
        }
        
        // Add additional octave for each 12 frets
        octaveOffset += Math.floor(fretNum / 12);
        
        return baseOctave + octaveOffset;
    }

    drawLiveDetectedNotes(detectedNotes) {
        // Draw highlighted circles on all detected notes (matching both name and octave)
        // detectedNotes is an array of: { name: "C", octave: 2, frequency: 130.81, fullName: "C2", detectedFrequency: 131.2, cents: 5.2, confidence: 0.95 }
        
        for (const detectedNote of detectedNotes) {
            const noteName = detectedNote.name;
            const noteOctave = detectedNote.octave;
            
            // Find the specific instance of this note with matching octave on the fretboard
            for (let stringNum = 1; stringNum <= numOfStrings; stringNum++) {
                for (let fretNum = firstNoteFret; fretNum <= numOfFrets; fretNum++) {
                    let fretNoteName = this.stringNotes[stringNum][fretNum];
                    let fretOctave = this.getOctaveForFret(stringNum, fretNum);
                    
                    // Match both the note name AND octave
                    if (fretNoteName === noteName && fretOctave === noteOctave) {
                        // Get note position
                        let x = this.frets.getNoteXPos(fretNum);
                        let y = this.strings.getYPos(stringNum);
                        
                        // Draw a pulsing highlight circle
                        this.ctx.beginPath();
                        this.ctx.arc(x, y, noteDiam + 8, 0, 2 * Math.PI);
                        this.ctx.strokeStyle = '#ff00ff'; // Magenta for live detection
                        this.ctx.lineWidth = 4;
                        this.ctx.stroke();
                        
                        // Draw the note itself with a special color
                        this.ctx.beginPath();
                        this.ctx.arc(x, y, noteDiam, 0, 2 * Math.PI);
                        this.ctx.fillStyle = '#ff00ff'; // Magenta fill
                        this.ctx.fill();
                        
                        // Draw the note name in white
                        this.ctx.font = noteFont;
                        this.ctx.textAlign = "center";
                        this.ctx.textBaseline = "middle";
                        this.ctx.fillStyle = 'white';
                        this.ctx.fillText(noteName, x, y);
                    }
                }
            }
        }
    }

}



// notes in the key (key)



class KeyNotes {
    

    constructor(key, validkeyNoteNumbers) {

        this.cSharpNoteNames = new Array('C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B');
        this.cFlatNoteNames = new Array('C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B');
        this.cNoteNames = this.cSharpNoteNames;

       
        this.noteNumbers = new Array('1', 'b2', '2', 'b3', '3', '4', 'b5', '5', 'b6', '6', 'b7', '7');
        this.keyNoteNames = new Array(' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ');
        this.stringNoteNames = new Array(' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ');
        this.stringNutNotes = new Array('F', 'A', 'D', 'G', 'B', 'E');

        this.key = key;
        this.createKeyNotes(key);
        this.validkeyNoteNumbers = validkeyNoteNumbers;
    }

    toFlat(noteName) {
        var i = 0;
        while (this.cNoteNames[i] != noteName) {
            i++;
        }

        return this.cFlatNoteNames[i];
    }
    

    // create a note array for the key, starting at the supplied key
    // this includes semitones
    createKeyNotes(key) {
        var i = 0;
        while (this.cNoteNames[i] != key) {
            i++;
            console.log(this.cNoteNames[i]);
            console.log(i);
        }

        console.log(this.keyInd);
        var keyInd = i;
        for (var i = keyInd; i < (keyInd + notesInKey); i++) {
            var pos = i - keyInd;
           
            var cPos = i % notesInKey;
            
            this.keyNoteNames[pos] = (this.cNoteNames[cPos]);
        }
    }

    checkValid(noteNum) {
        return this.validkeyNoteNumbers.includes(noteNum);

    }

    // get position from note number

    findNoteNumPosn(noteNum) {
        let i = 0;
        while (this.noteNumbers[i] != noteNum) {
            i++;
        }
        return i;
    }

    // get note number for array position

    numForPosn(posn) {
        return this.noteNumbers[posn];
    }

    // get position for note name in keyNoteNames

    findNoteNamePosn(name) {
        let i = 0;
        while (this.keyNoteNames[i] != name) {
            i++;
        }
        return i;
    }

    // get note from posn in keyNoteNames
    keyNoteForPosn(posn) {
        return this.keyNoteNames[posn];
    }

    nameNoteFromNum(num) {
        let posn = this.findNumPosn(num);
        return this.keyNoteNames[posn];
    }

    numNoteFromName(name) {
        let posn = this.findNoteNamePosn(name);
        return this.noteNumbers[posn];
    }
}


class SelectionNotes {
    constructor(sel) {


        let majorScale = new Array("1", "2", "3", "4", "5", "6", "7");

        let majorChord = new Array("1", "3", "5");
        let major7Chord = new Array("1", "3", "5", "7");

        let major11Chord = new Array("1", "2", "3","4", "5", "7");
        let major13Chord = new Array("1", "3","4", "5","6", "7");



        let minorChord = new Array("1", "b3", "5");
        let minor7Chord = new Array("1", "b3", "5","b7");

        let minor11Chord = new Array("1", "2", "b3", "4", "5", "b7");
        let minor13Chord = new Array("1", "2", "b3", "4", "5","6", "b7");


        let dom7thChord = new Array("1", "3", "5", "b7");
        let dimChord = new Array("1", "b3", "b5");
        let dim7thChord = new Array("1", "b3", "b5", "6");


        let augChord = new Array("1", "3", "b6");
        let hendrixChord = new Array("1", "b3", "3", "b7", "9");

        let majorPent = new Array("1", "2", "3", "5", "6");
        let minorPent = new Array("1", "b3", "4", "5", "b7");
        let dim7thScale = new Array("1", "2", "b3", "4", "b5", "b6", "6", "7");

        let ionian = new Array('1', '2', '3', '4', '5', '6', '7');
        let dorian = new Array('1', '2', 'b3', '4', '5', '6', 'b7');
        let phrygian = new Array('1', 'b2', 'b3', '4', '5', 'b6', 'b7');
        let lydian = new Array('1', '2', '3', 'b5', '5', '6', '7');
        let mixolydian = new Array('1', '2', '3', '4', '5', '6', 'b7');
        let aeolian = new Array('1', '2', 'b3', '4', '5', 'b6', 'b7');
        let locrian = new Array('1', 'b2', 'b3', '4', 'b5', 'b6', 'b7');

        let blues = new Array("1", "b3", "4", "b5", "5", "b7");
        let bluesMajor = new Array("1", "2", "b3", "3", "5", "6");
        let minorHarmonic = new Array("1", "2", "b3", "4", "5", "b6", "7");
        let minorMelUp = new Array("1", "2", "b3", "4", "5", "6", "7");
        let minorMelDown = new Array("1", "2", "b3", "4", "5", "b6", "b7");
        let minor = new Array("1", "2", "b3", "4", "5", "b6", "b7");



       
        let mixoBlues = new Array('1', '2', "b3", '3', '4', "b5", '5', '6', 'b7');
        let majorPlusBlues = new Array('1', '2', 'b3', '3', '4', 'b5', '5', '6', 'b7', '7');



        this.selNotes = new Array();

        if (sel == 'majorScale')
            this.selNotes = majorScale;
        else if (sel === 'majorScale(Targets)')
            this.selNotes = majorScale;
        else if (sel === 'majorScale(CAGED)')
            this.selNotes = majorScale;  
        else if (sel === 'majorChord')
            this.selNotes = majorChord;
        else if (sel === 'majorChord(CAGED)')
            this.selNotes = majorChord;
        else if (sel === 'minorChord')
            this.selNotes = minorChord;
        else if (sel === 'minorChord(CAGED)')
            this.selNotes = minorChord;
        else if (sel === 'major7Chord')
            this.selNotes = major7Chord;
        else if (sel ==='major7Chord(CAGED)')
            this.selNotes = major7Chord;
        else if (sel === 'minor7Chord')
            this.selNotes = minor7Chord;
        else if (sel === 'minor7Chord(CAGED)')
            this.selNotes = minor7Chord;
        else if (sel === 'minor11Chord')
            this.selNotes = minor11Chord;
        else if (sel === 'minor11Chord(CAGED)')
            this.selNotes = minor11Chord;
        else if (sel === 'minor13Chord')
            this.selNotes = minor13Chord;
        else if (sel === 'minor13Chord(CAGED)')
            this.selNotes = minor13Chord;
        else if (sel === 'majorPent')
            this.selNotes = majorPent;
        else if (sel === 'majorPent(CAGED)')
            this.selNotes = majorPent;
        else if (sel === 'minorPent')
            this.selNotes = minorPent;
        else if (sel === 'minorPent(CAGED)')
            this.selNotes = minorPent;
        else if (sel === 'dim7thScale')
            this.selNotes = dim7thScale;
        else if (sel === 'blues')
            this.selNotes = blues;
        else if (sel === 'blues(CAGED)')
            this.selNotes = blues;
        else if (sel === 'bluesMajor')
            this.selNotes = bluesMajor;
        else if (sel === 'bluesMajor(CAGED)')
            this.selNotes = bluesMajor;
        else if (sel === 'minorHarmonic')
            this.selNotes = minorHarmonic;
        else if (sel === 'minorMelUp')
            this.selNotes = minorMelUp;
        else if (sel === 'minorMelDown')
            this.selNotes = minorMelDown;
        else if (sel === 'minorScale')
            this.selNotes = minorMelDown;
        else if (sel === 'minorScale(CAGED)')
            this.selNotes = minorMelDown;
        else if (sel === 'dom7thChord')
            this.selNotes = dom7thChord;
        else if (sel === 'augChord')
            this.selNotes = augChord;
        else if (sel === 'dimChord')
            this.selNotes = dimChord;
        else if (sel === 'dim7thChord')
            this.selNotes = dim7thChord;
        else if (sel === 'hendrixChord')
            this.selNotes = hendrixChord;
        else if (sel === 'mixoBlues')
            this.selNotes = mixoBlues;
        else if (sel === 'majorPlusBlues')
            this.selNotes = majorPlusBlues;
        else if (sel === 'ionian')
            this.selNotes = ionian;
        else if (sel === 'ionian(CAGED)')
            this.selNotes = ionian;
        else if (sel === 'dorian')
            this.selNotes = dorian;
        else if (sel === 'dorian(CAGED)')
            this.selNotes = dorian;
        else if (sel == 'phrygian')
            this.selNotes = phrygian;
        else if (sel === 'phrygian(CAGED)')
            this.selNotes = phrygian;
        else if (sel === 'lydian')
            this.selNotes = lydian;
        else if (sel === 'lydian(CAGED)')
            this.selNotes = lydian;
        else if (sel === 'mixolydian')
            this.selNotes = mixolydian;
        else if (sel === 'mixolydian(CAGED)')
            this.selNotes = mixolydian;
        else if (sel === 'aeolian')
            this.selNotes = aeolian;
        else if (sel === 'aeolian(CAGED)')
            this.selNotes = aeolian;
        else if (sel === 'locrian')
            this.selNotes = locrian;
        else if (sel === 'locrian(CAGED)')
            this.selNotes = locrian;
        else
            this.selNotes = majorPent;

    }

    getSelNotes() {

        return this.selNotes;
    }

}

// core
const nutNote = ['E', 'A', 'D', 'G', 'B', 'E'];
const numOfFrets = 15;
const numOfStrings = 6;
const bgColor = "white";
const borderColor = "black";
const stringColor = "black";
const fretColor = "black";  
const noteChordColor = "blue";
const notePentColor = "green";
const noteModeColor = "yellow"
const notesInKey = 12;
let key = "D";

//caged
const cagedBoxLineWidth = 8;

//inlays
const inlayColor = "lightgrey";
const inlayDiam = 14;

// nut

const nutColor = "lightgrey";
const nutWidth = 65;
const nutTextColor = "black";



// notes
const firstNoteFret = 0;
const noteDiam = 21;
const noteFont = "20px Arial";
const noteSmallFont = "18px Arial";
const noteColor = "black";
const noteTextColor = "white";
const noteColorRoot = "orange";
const noteTextColorRoot = "black";

// nash numbers 
const nashNumDiam = 7
const nashMax = 7
const nashFont = "5px Arial";
let nashColors = new Array("red", "blue", "green", "orange", "yellow",'white','purple');
let nashText = new Array("I", "ii", "iii", "IV", "V", 'vi', 'vii');


//internal
let cagedColors = new Array("red", "blue", "green", "orange", "yellow");


export default class GuitarApp {
    constructor(ctx, width, height,key, sel, notesOrNumbers, sharpsOrFlats, bgColor, liveMode = false, detectedNotes = []) {

        this.bgColor = bgColor;
        this.liveMode = liveMode;
        this.detectedNotes = detectedNotes;

        //this.noteNotNum = (noteNotNum == true)?true:false;

        let selectionNotes = new SelectionNotes(sel);
        let selNotes = selectionNotes.getSelNotes();
      
        // main section
        //let c = document.getElementById(id);
        
        //let ctx = c.getContext("2d");
       

        let fbRect = new Rect(0, 0, width, height,)
        ctx.clearRect(0,0,width, height);
        
        let neck = new Neck(ctx, fbRect, nutWidth);
        let frets = new Frets(ctx, neck.getFbRect());
        let strings = new Strings(ctx, neck.getFbRect(), nutWidth, stringColor);
        let fretboardNotes = new FretboardNotes(ctx, frets, strings, sharpsOrFlats);
        let keyNotes = new KeyNotes(key, selNotes);
        

        neck.draw();
        
        frets.drawFrets();
        //fretboardNotes.drawFretboardCagedShapes(keyNotes, neck);

        strings.drawStrings();
        fretboardNotes.drawInlays();

        let showTargets = false;

        if (sel === "majorChord(CAGED)" || sel === "majorPent(CAGED)"
            || sel === "bluesMajor(CAGED)"
            || sel === "majorScale(CAGED)"
            || sel === "mixolydian(CAGED)"
            || sel === "lydian(CAGED)"
            || sel === "ionian(CAGED)"
            || sel === "major7Chord(CAGED)"
            || sel === "major11Chord(CAGED)"
           

        )
            fretboardNotes.drawCagedMajShapes(keyNotes, neck);
        if (sel === "minorChord(CAGED)" || sel === "minorPent(CAGED)"
            || sel === "blues(CAGED)" || sel === "minorScale(CAGED)"
            || sel === "dorian(CAGED)"
            || sel === "phrygian(CAGED)"
            || sel === "aeolian(CAGED)"
            || sel === "minor7Chord(CAGED)"
            || sel ==="minor11Chord(CAGED)"
                  )
            fretboardNotes.drawCagedMinShapes(keyNotes, neck);

        ctx.lineWidth = 1;

        if ( sel == "majorScale(Targets)" )
            showTargets = true;


        fretboardNotes.drawFretboardNotes(keyNotes, notesOrNumbers,showTargets);
        
        // If in live mode, highlight the detected notes
        if (this.liveMode && this.detectedNotes && this.detectedNotes.length > 0) {
            fretboardNotes.drawLiveDetectedNotes(this.detectedNotes);
        }
     
    }
}




        //app2 = new App("myCanvas2");

        // scale - chord - note
        // to define which of the 12 notes in the scale
        // starting at the key


        // translate scale to fretboard
        // 
        // input - nut notes - starting notes for each string
        // input - key
        // input - scale - holding notes in key


/*function selFretsChange(selObject) {
    numOfFrets = selObject.value;
    id = selObject.target.id;
    app = new GuitarApp(id);
}*/




